import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    target: Number,
    duration: { type: Number, default: 2000 },
    suffix: { type: String, default: "" },
  }

  declare targetValue: number
  declare durationValue: number
  declare suffixValue: string

  connect() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.animate()
            observer.unobserve(entry.target)
          }
        })
      },
      { threshold: 0.3 }
    )
    observer.observe(this.element)
  }

  animate() {
    const end = this.targetValue
    const duration = this.durationValue
    const startTime = performance.now()
    const el = this.element as HTMLElement

    const step = (currentTime: number) => {
      const progress = Math.min((currentTime - startTime) / duration, 1)
      const eased = 1 - Math.pow(1 - progress, 3) // ease-out cubic
      const current = Math.floor(eased * end)
      el.textContent = current.toLocaleString("de-DE") + this.suffixValue
      if (progress < 1) requestAnimationFrame(step)
    }
    requestAnimationFrame(step)
  }
}
